import axios from "axios";

export const GetIP = () => {
  return axios.get("https://geolocation-db.com/json/");
};
